module.exports = __webpack_public_path__ + "img/avatar5.276a33c2.png";